import React, { useState, useCallback, useRef, Fragment } from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  IconButton,
  Button,
  Avatar,
  Box,
  Accordion,
  AccordionSummary,
  Typography,
  TextField
} from "@mui/material";
import CachedIcon from '@mui/icons-material/Cached';
import withStyles from '@mui/styles/withStyles';
import PlayCirlceOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import EnhancedTableHead from "../../../shared/components/EnhancedTableHead";
import stableSort from "../../../shared/functions/stableSort";
import getSorting from "../../../shared/functions/getSorting";
import HighlightedInformation from "../../../shared/components/HighlightedInformation";
import ConfirmationDialog from "../../../shared/components/ConfirmationDialog";
import { Auth } from 'aws-amplify';
const styles = (theme) => ({
  tableWrapper: {
    overflowX: "auto",
  },
  alignRight: {
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
  },
  blackIcon: {
    color: theme.palette.common.black,
  },
  avatar: {
    width: 28,
    height: 28,
  },
  firstData: {
    paddingLeft: theme.spacing(3),
  },
  iconButton: {
    padding: theme.spacing(1),
  },
  dBlock: {
    display: "block",
  },
  dNone: {
    display: "none",
  },
});

const rows = [
  {
    id: "icon",
    numeric: true,
    label: "",
  },
  {
    id: "name",
    numeric: false,
    label: "Name",
  },
  { id: "number1", numeric: false, label: "Category 1" },
  { id: "number2", numeric: false, label: "Category 2" },
  { id: "number3", numeric: false, label: "Category 3" },
  {
    id: "number4",
    numeric: false,
    label: "Category 4",
  },
  {
    id: "actions",
    numeric: false,
    label: "",
  },
];

const rowsPerPage = 25;
function getAPIKey(){

  return Auth.currentSession().then(res=>{
    let idToken = res.getIdToken();
    var jwt = idToken.getJwtToken();
    // console.log(jwt);
    return jwt
    //You can print them to see the full objects
    // console.log(`myAccessToken: ${JSON.stringify(jwt)}`);

  }).catch(err => {
    console.log("error",err)
    return null
  }).then(jwt => {if (jwt !== "undefined"){
    // console.log(`myAccessToken: ${JSON.stringify(jwt)}`);
    if (jwt !== null){
      const headers = {"Authorization": "Bearer "+jwt}
      return fetch(`${process.env.REACT_APP_USAGE_API}`+`${process.env.REACT_APP_API_KEY_ENDPOINT}`, {headers:headers})
          .then(response => {
          return response.json()
        }).catch(err=>{
            console.log("error",err)
            return null
      });
    } else{
      return null
    }

  }});

}
function getUsagePlan(){

  return Auth.currentSession().then(res=>{
    let idToken = res.getIdToken();
    var jwt = idToken.getJwtToken();
    // console.log(jwt);
    return jwt
    //You can print them to see the full objects
    // console.log(`myAccessToken: ${JSON.stringify(jwt)}`);

  }).catch(err => {
    console.log("error",err)
    return null
  }).then(jwt => {if (jwt !== "undefined"){
    // console.log(`myAccessToken: ${JSON.stringify(jwt)}`);
    console.log(`${process.env.REACT_APP_PROJECT_NAME}`);
    if (jwt !== null){
      const headers = {"Authorization": "Bearer "+jwt}
      return fetch(`${process.env.REACT_APP_USAGE_API}`+`${process.env.REACT_APP_PLAN_USAGE_ENDPOINT}`, {method:"POST",body:JSON.stringify({"project_name":`${process.env.REACT_APP_PROJECT_NAME}`}),headers:headers})
          .then(response => {
          return response.json()
        }).catch(err=>{
            console.log("error",err)
            return null
      });
    } else{
      return null
    }

  }});

}
function regenAPIKey(){

  return Auth.currentSession().then(res=>{
    let idToken = res.getIdToken();
    var jwt = idToken.getJwtToken();
    // console.log(jwt);
    return jwt
    //You can print them to see the full objects
    // console.log(`myAccessToken: ${JSON.stringify(jwt)}`);

  }).catch(err => {
    console.log("error",err)
    return null
  }).then(jwt => {if (jwt !== "undefined"){
    // console.log(`myAccessToken: ${JSON.stringify(jwt)}`);
    if (jwt !== null){
      const headers = {"Authorization": "Bearer "+jwt}
      return fetch(`${process.env.REACT_APP_USAGE_API}`+`${process.env.REACT_APP_REGEN_API_KEY_ENDPOINT}`, {method:"POST",headers:headers})
          .then(response => {
          return response.json()
        }).catch(err=>{
            console.log("error",err)
            return null
      });
    } else{
      return null
    }

  }});

}
function CustomTable(props) {
  const { pushMessageToSnackbar, classes, apiKey, setApiKey, usage, setUsage} = props;
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState(null);
  const [page, setPage] = useState(0);
  // const [setApiKey, targets] = useState(null);
  // const api_key = useRef(null);


  if(Object.keys(usage).length === 0){
    getUsagePlan().then(api_data => {if (api_data !== null) {setUsage(api_data.response.resultMessage)}});
    localStorage.setItem("presage-usage", "NOTHING HERE");
  }


  return (


      <Box width="100%">
        <div>
         <Fragment>
          {apiKey !== null ? (

              <span title="Click to copy">
              <Typography onClick={() => {navigator.clipboard.writeText(apiKey)}} onChange={setApiKey}>
                API Key: {apiKey}
                <span title="Click to reset API key">
                <Button style={{marginLeft:15}} type="submit" variant="contained" onClick={() => {regenAPIKey().then(output=>{if (output.response.resultStatus === "SUCCESS"){setApiKey(output.response.resultMessage)}})}}>
                  Reset Key
                </Button>
                </span>

              </Typography>
              </span>





          ) : (

            <span title="Click to reveal">

            <Typography onClick={() => {getAPIKey().then(api_data => {if (api_data !== null) {setApiKey(api_data.response.resultMessage)}})}}>

            API Key: ******************

            </Typography>
            </span>

          )}
          </Fragment>

          {Object.keys(usage).length !== 0 ? (
            <Fragment>
              <Typography style={{ textTransform: 'capitalize'}}>
                Tier: {usage.tier_information.tier_name}
              </Typography>
              <Typography>

                Current Usage: {parseFloat(usage.credits_remaining).toFixed(2)}/{parseFloat(usage.tier_information.credits).toFixed(2)} minutes

              </Typography>
              <Typography>
                Next Renewal: {usage.next_renewal}
              </Typography>
            </Fragment>

          ) : (
            <Fragment>
            <Typography>
            Tier: Loading...

            </Typography>
            <Typography>
            Current Usage: Loading...
            </Typography>
            <Typography>
            Next Renewal: Loading...


            </Typography>
            </Fragment>


          )}
          <Fragment>
          <br/>
          <a href="https://colab.research.google.com/github/Presage-Security/presage_technologies/blob/main/examples/Physiology_API_Example.ipynb" target="_blank" rel="nofollow">
          <img src="https://colab.research.google.com/assets/colab-badge.svg" alt="Open In Colab"/>
          </a>
          </Fragment>
        </div>
      </Box>

  );

}

CustomTable.propTypes = {
  classes: PropTypes.object.isRequired,
  apiKey: PropTypes.string,
  setApiKey: PropTypes.func.isRequired,
  pushMessageToSnackbar: PropTypes.func,
};

export default withStyles(styles, { withTheme: true })(CustomTable);
